import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/site/wwwroot/node_modules/next-intl/dist/esm/production/navigation/shared/BaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/site/wwwroot/node_modules/next-intl/dist/esm/production/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager" */ "/home/site/wwwroot/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/home/site/wwwroot/public/medias/no-image.jpg");
;
import(/* webpackMode: "eager" */ "/home/site/wwwroot/public/medias/where-to-buy/egypt-1.png");
;
import(/* webpackMode: "eager" */ "/home/site/wwwroot/public/medias/where-to-buy/egypt-2.png");
;
import(/* webpackMode: "eager" */ "/home/site/wwwroot/public/medias/where-to-buy/egypt.svg");
;
import(/* webpackMode: "eager" */ "/home/site/wwwroot/public/medias/where-to-buy/iraq-1.png");
;
import(/* webpackMode: "eager" */ "/home/site/wwwroot/public/medias/where-to-buy/iraq-2.png");
;
import(/* webpackMode: "eager" */ "/home/site/wwwroot/public/medias/where-to-buy/iraq.png");
;
import(/* webpackMode: "eager" */ "/home/site/wwwroot/public/medias/where-to-buy/ksa-1.png");
;
import(/* webpackMode: "eager" */ "/home/site/wwwroot/public/medias/where-to-buy/ksa-2.png");
;
import(/* webpackMode: "eager" */ "/home/site/wwwroot/public/medias/where-to-buy/ksa.webp");
;
import(/* webpackMode: "eager" */ "/home/site/wwwroot/public/medias/where-to-buy/pakistan-1.png");
;
import(/* webpackMode: "eager" */ "/home/site/wwwroot/public/medias/where-to-buy/pakistan.webp");
;
import(/* webpackMode: "eager" */ "/home/site/wwwroot/public/medias/where-to-buy/usAndCanada.png");
;
import(/* webpackMode: "eager" */ "/home/site/wwwroot/public/medias/where-to-buy/usCanada1.png");
;
import(/* webpackMode: "eager" */ "/home/site/wwwroot/src/components/pages/blogs/index/header/styles.module.css");
;
import(/* webpackMode: "eager" */ "/home/site/wwwroot/src/components/pages/blogs/single/tag/styles.module.css");
;
import(/* webpackMode: "eager" */ "/home/site/wwwroot/src/components/pages/home/insights/styles.module.css");
